import { KAKAO_CLIENT_ID, LOGIN_REDIRECT_URI } from "../Config";

export const getKakaoLoginUrl = () => {
    const params = new URLSearchParams({
        client_id: process.env.REACT_APP_KAKAO_CLIENT_ID,
        redirect_uri: `${LOGIN_REDIRECT_URI}/kakao`,
        response_type: "code",
        prompt: "select_account"
    });

    return `https://kauth.kakao.com/oauth/authorize?${params.toString()}`;
};